import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      version="1.1"
      viewBox="0 0 24 24"
      style={{ WebkitPrintColorAdjust: "exact", fill:"none" }}
    >
      <g clipPath="url(#frame-clip-e404a610-94c9-11ec-a547-e7091bb4fd45-aaa6de50-94ca-11ec-a923-e7d894e359c9)">
        <defs>
          <clipPath
            id="frame-clip-e404a610-94c9-11ec-a547-e7091bb4fd45-aaa6de50-94ca-11ec-a923-e7d894e359c9"
            className="frame-clip"
          >
            <path d="M0 0H24V24H0z"></path>
          </clipPath>
        </defs>
        <path
          strokeWidth="2"
          d="M4 10c0-4.415 2.585-7 7-7h3c4.415 0 7 2.585 7 7h0c0 4.415-2.585 7-7 7h-3c-6 0-7 4.966-7 3.172V10zh0zh0z"
        ></path>
      </g>
    </svg>
  );
}

export default Icon;
